import { $authHost } from "../../http";
import { 
    PURPOSE_OF_SELECTION_GET_REQUEST, PURPOSE_OF_SELECTION_GET_SUCCESS, PURPOSE_OF_SELECTION_GET_ERROR, 
    PURPOSE_OF_SELECTION_GET_BY_KEY_REQUEST, PURPOSE_OF_SELECTION_GET_BY_KEY_SUCCESS, PURPOSE_OF_SELECTION_GET_BY_KEY_ERROR, 
    PURPOSE_OF_SELECTION_ADD_REQUEST, PURPOSE_OF_SELECTION_ADD_SUCCESS, PURPOSE_OF_SELECTION_ADD_ERROR, 
    PURPOSE_OF_SELECTION_EDIT_REQUEST, PURPOSE_OF_SELECTION_EDIT_SUCCESS, PURPOSE_OF_SELECTION_EDIT_ERROR, 
    PURPOSE_OF_SELECTION_DELETE_REQUEST, PURPOSE_OF_SELECTION_DELETE_SUCCESS, PURPOSE_OF_SELECTION_DELETE_ERROR
} from "../constants/purposeOfSelectionConstants";

export const getPurposeOfSelections = (args) => async (dispatch) => {
    try {
        dispatch({
            type: PURPOSE_OF_SELECTION_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/purposeOfSelection/query",
            args || {},
            config,
        );
        dispatch({
            type: PURPOSE_OF_SELECTION_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: PURPOSE_OF_SELECTION_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getPurposeOfSelectionByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: PURPOSE_OF_SELECTION_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/purposeOfSelection/${id}`,
        );
        dispatch({
            type: PURPOSE_OF_SELECTION_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: PURPOSE_OF_SELECTION_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addPurposeOfSelection = ({ name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: PURPOSE_OF_SELECTION_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/purposeOfSelection",
            { name, code, description },
            config,
        );
        dispatch(getPurposeOfSelections(queryArgs || {}));
        dispatch({
            type: PURPOSE_OF_SELECTION_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: PURPOSE_OF_SELECTION_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editPurposeOfSelection = ({ id, name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: PURPOSE_OF_SELECTION_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/purposeOfSelection",
            { id, name, code, description },
            config,
        );
        dispatch(getPurposeOfSelections(queryArgs || {}));
        dispatch({
            type: PURPOSE_OF_SELECTION_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: PURPOSE_OF_SELECTION_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deletePurposeOfSelection = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: PURPOSE_OF_SELECTION_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/purposeOfSelection",
            { data: { id } },
            config,
        );
        dispatch(getPurposeOfSelections(queryArgs || {}));
        dispatch({
            type: PURPOSE_OF_SELECTION_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: PURPOSE_OF_SELECTION_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

